import postMessage from "./PostMessage";

function loadAjaxInterceptor(frame, targetOrigin) {
  return new Promise(function(resolve) {
    function ajaxInterceptor() {
      (function(open) {
        function sendErrorEvent(status) {
          _ab.events.emit("httpError", {
            status: status
          });
        }

        XMLHttpRequest.prototype.setABTastyErrorListener = function() {
          this.addEventListener(
            "readystatechange",
            function(e) {
              var status = this.status;
              if (this.readyState == 4) {
                if ([400, 401, 403, 500].indexOf(status) > -1) {
                  sendErrorEvent(status);
                  return;
                }
              }
            },
            false
          );
          this.addEventListener(
            "error",
            function(e) {
              sendErrorEvent("error");
            },
            false
          );
        };

        XMLHttpRequest.prototype.open = function(
          method,
          url,
          async,
          user,
          pass
        ) {
          this.setABTastyErrorListener();
          open.call(this, method, url, async, user, pass);
        };
      })(XMLHttpRequest.prototype.open);
    }

    const moduleDataStr = ajaxInterceptor.toString();
    postMessage(frame, "evalCode", `(${moduleDataStr})()`, targetOrigin || "*");
    resolve();
  });
}

export default {
  loadAjaxInterceptor
};
